import type { ExternalTableSchema } from '@packages/table-builder';

export const grantsManagementTable: ExternalTableSchema = {
  metadata: {
    title: 'Grant Management',
    entity: 'Grant',
  },

  dataSource: {
    endpoint: '/api/award/api/app/grant/grant-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      PlanId: 'filters.planId',
      GrantTypeId: 'filters.grantTypeId',
    },
    filters: [
      {
        name: 'planId',
        placeholder: 'Plan Name',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/grant/plans',
          labelField: 'planName',
          valueField: 'planId',
        },
      },
      {
        name: 'grantTypeId',
        placeholder: 'Grant Type',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/grant/plan-types',
          labelField: 'name',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'grantName',
      header: 'Grant Name',
      type: 'text',
      sortable: true,
      width: 280,
      visibility: 'locked',
    },
    {
      field: 'planTypeName',
      header: 'Grant Type',
      type: 'badge',
      sortable: true,
      align: 'center',
      badge: {
        statusMap: {
          RSU: 'success',
          ISO: 'primary',
          PSU: 'pink-tag',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'vestingScheduleName',
      header: 'Vesting Schedule',
      type: 'text',
      sortable: true,
      width: 250,
    },
    {
      field: 'planName',
      header: 'Plan Name',
      type: 'text',
      sortable: true,
      width: 250,
    },
    {
      field: 'poolName',
      header: 'Pool Name',
      type: 'text',
      sortable: true,
      width: 250,
    },
    {
      field: 'grantStatus',
      header: 'Grant Vest Status',
      type: 'text',
      sortable: true,
      width: 150,
      align: 'center',
    },
    {
      field: 'acceptanceMethodName',
      header: 'Acceptance Method',
      type: 'text',
      sortable: true,
      width: 150,
      align: 'center',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_GRANT_MANAGEMENT', label: 'View' },
      { id: 'EDIT_GRANT_MANAGEMENT', label: 'Edit' },
      { id: 'DELETE_GRANT_MANAGEMENT', label: 'Delete', variant: 'danger' },
    ],
    bulk: [{ id: 'BULK_EXPORT_GRANT_MANAGEMENT', label: 'Bulk Export', icon: 'download' }],
    toolbar: {
      primary: { id: 'ADD_GRANT_MANAGEMENT', label: 'Add Grant', icon: 'add_circle_outline' },
      secondary: [
        {
          label: 'Downloads',
          icon: 'download',
          type: 'download',
          children: [{ id: 'DOWNLOAD_TEMPLATE_GRANT_MANAGEMENT', label: 'Download Template' }],
        },
        {
          label: 'Import',
          icon: 'upload',
          type: 'upload',
          children: [{ id: 'IMPORT_GRANT_MANAGEMENT', label: 'Import Bulk XLS' }],
        },
      ],
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    selection: { keyField: 'id', selectAllPages: true },
    columnPreferences: { persistenceKey: 'Grant', resizable: true, reorderable: true },
  },
};
